<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="备件名称">
              <a-input allowClear placeholder="请输入备件名称" v-debounce="searchQuery" v-model="queryParam.bjName" />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="9" :sm="12">
            <a-form-item label="备件类型">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="bpbj_type"
                type="checkbox"
                v-model="queryParam.bpbjType"
              />
            </a-form-item>
          </a-col>-->
          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <template v-if="pageType!=='select'">
        <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
        <a-button @click="handleExportXls('备品备件基本信息')" icon="download" type="primary">导出</a-button>
        <a-upload
          :action="importExcelUrl"
          :headers="tokenHeader"
          :multiple="false"
          :showUploadList="false"
          @change="handleImportExcel"
          name="file"
        >
          <a-button icon="import" type="primary">导入</a-button>
        </a-upload>
      </template>
      <!-- 高级查询区域 -->

      <a-dropdown v-if="selectedRowKeys.length > 0&&pageType==='query'">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record" v-if="pageType==='query'">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <dev-bpbj-info-modal @ok="modalFormOk" ref="modalForm"></dev-bpbj-info-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  import DevBpbjInfoModal from './modules/DevBpbjInfoModal'

  export default {
    name: 'DevBpbjInfoList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      DevBpbjInfoModal
    },
    props: {
      pageType: {
        type: String,
        default: 'query'
      }
    },
    data () {
      return {
        description: '备品备件基本信息管理页面',
        // 表头
        columns: [
          {
            title: '备件名称',
            align: 'center',
            dataIndex: 'bjName',
            sorter: true,
          },
          {
            title: '生产厂家',
            align: 'center',
            dataIndex: 'manuName',
            sorter: true,
          },
          {
            title: '备件型号',
            align: 'center',
            dataIndex: 'bjModel',
            sorter: true,
          },
          {
            title: '备件型号规格',
            align: 'center',
            dataIndex: 'bjModelSpec',
            sorter: true,
          },
          {
            title: '应备数量',
            align: 'center',
            dataIndex: 'prepareCount',
            sorter: true,
          },
          {
            title: '初始库存',
            align: 'center',
            dataIndex: 'leftCount',
            sorter: true,
          },
          {
            title: '单位',
            align: 'center',
            dataIndex: 'unit',
            sorter: true,
          },
          {
            title: '备件类型',
            align: 'center',
            dataIndex: 'bpbjType',
            customRender: function (text) {
              return filterDictTextByCache('bpbj_type', text)
            }
          },
          {
            title: '适配设备类型',
            align: 'center',
            dataIndex: 'devClassName'
          },
          {
            title: '适配设备型号',
            align: 'center',
            dataIndex: 'devModelId_dictText'
          },
        ],
        url: {
          list: '/spareparts/devBpbjInfo/list',
          delete: '/spareparts/devBpbjInfo/delete',
          deleteBatch: '/spareparts/devBpbjInfo/deleteBatch',
          exportXlsUrl: '/spareparts/devBpbjInfo/exportXls',
          importExcelUrl: 'spareparts/devBpbjInfo/importExcel'

        },
        queryParam: {
          bjName: ''
        },
        dictOptions: {},
        superFieldList: []
      }
    },
    created () {
      if (this.pageType === 'query') {
        this.columns.push(
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          })
      }
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      },
      selectTableList () {
        return this.selectionRows
      }
    },
    methods: {

      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'bjCode', text: '备件物资编码' })
        fieldList.push({ type: 'string', value: 'bjName', text: '备件名称' })
        fieldList.push({ type: 'string', value: 'bjModel', text: '备件型号' })
        fieldList.push({ type: 'string', value: 'bjModelSpec', text: '备件型号规格' })
        fieldList.push({ type: 'number', value: 'prepareCount', text: '应备数量' })
        fieldList.push({ type: 'string', value: 'unit', text: '单位' })
        fieldList.push({ type: 'string', value: 'devClassId', text: '设备类型' })
        fieldList.push({ type: 'string', value: 'manuId', text: '设备厂家' })
        fieldList.push({ type: 'string', value: 'devModelId', text: '设备型号' })
        fieldList.push({ type: 'int', value: 'ageMonth', text: '寿命' })
        fieldList.push({ type: 'number', value: 'leftCount', text: '初始数量' })
        fieldList.push({ type: 'string', value: 'ywUnit', text: '运维单位' })
        fieldList.push({ type: 'int', value: 'delFlag', text: '删除状态' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
